import React, { useEffect, useState } from 'react';
import Checkbox from 'components/Checkbox/Checkbox';
import PrimeField from '../../PrimeField/PrimeField';

const RJCheckBox = (props) => {
  const options = props.options;
  const title = options.title;

  return (
    <div style={options.styles && options.styles.field}>
      <Checkbox
        checked={props?.value}
        onChange={e => props.onChange(e.target.checked)}
        label={title} />
    </div>
  );
};

export default RJCheckBox;